import { supplierIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const deleteSupplier = {
  name: "deleteSupplier" as const,
  input: z.object({ supplierId: supplierIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
